<template>
    <div>
        <div style="padding: 0 20px">
            <!--    新增角色按钮-->
            <div class="top" style="justify-content: space-between">
                <div>
                    <el-select v-if = "pharmacyShow" size = "small" v-model="query.pharmacyId" placeholder="选择药房" style="width: 120px;">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in pharmacies" :key="item.id"
                                    :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="query.medicinalName"
                              size="small"
                              placeholder="器械名称/通用名"
                              suffix-icon="el-icon-search"
                              style="width: 160px;margin-left: 20px">
                    </el-input>
                    <el-select  v-model="query.medicinalParentType" @change="chooseParentType" size="small" style="width: 120px;margin-left: 20px">
                        <el-option key="JIA_YONG_QI_XIE" label="家用器械" value="JIA_YONG_QI_XIE"></el-option>                     
                    </el-select>
                    <el-select  v-model="query.medicinalType" size="small" style="width: 120px;margin-left: 20px">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in typeDetailList" :key="item.typeCode"
                                    :label="item.typeName" :value="item.typeCode"></el-option>
                    </el-select>
                     <el-select v-model="query.medicineStatus" size="small" style="width: 120px;margin-left: 20px">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option key="SHELF" label="已上架" value="SHELF"></el-option>
                        <el-option key="OBTAINED" label="已下架" value="OBTAINED"></el-option>
                    </el-select>
                    <el-button type="primary" @click="search" style="width: 68px;">查询</el-button>
                   <el-button type="primary" @click="openAdd" style="width: 68px;">新增</el-button>
                </div>
                <div style="display:flex">
                   <el-button size="small" style="width: 96px;float:right;margin-right:10px" @click="excelExport">下载模板</el-button>
                   <el-button size="small" style="width: 96px;" @click="dataExport">批量导出</el-button>                   
                   <el-upload
                    style="display: inline-block; margin-left:10px;margin-right:10px;width:96px;float:right;" 
                    action=""
                    :multiple="false"
                    :limit=1                    
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :show-file-list="false"
                    :drag="false"
                    :http-request="uploadFile"
                    ref="excel"
                    >
                    <el-button size="small" style="width: 96px;float:left">批量导入</el-button>
                    </el-upload>                
                    
                </div>
            </div>
            <!--    角色信息表格-->
            <div>
                <el-table :data="tableData" v-loading="loading">
             
                    <el-table-column label="器械名称" prop="productName"></el-table-column>
                    <el-table-column label="通用名"   prop="productPharmacyName"></el-table-column>
                    <el-table-column label="器械分类" prop="productTypeName"></el-table-column>
                    <el-table-column label="所属类别" prop="productSubTypeName"></el-table-column>
                    <el-table-column label="规格"     prop="specification"></el-table-column>            
                    <el-table-column label="常规单位" prop="quantityUnit"></el-table-column>                    
                    <el-table-column label="零售单价" prop="price"></el-table-column>                   
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 'SHELF'">已上架</span>
                            <span v-else-if="scope.row.status === 'OBTAINED'">已下架</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editMedicinal(scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.status === 'OBTAINED'" type="text" @click="changeStatus(scope.row)">上架</el-button>
                            <el-button v-else-if="scope.row.status === 'SHELF'" type="text" @click="changeStatus(scope.row)">下架</el-button>
                            <el-button type="text" @click="openDividedSet(scope.row)">提成设置</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增" :visible.sync="dialogAddVisible" width="760px" :close-on-click-modal="false">
        
            <el-form :model="medicinalAdd" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px">
                <el-card class="box-card">
                     <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="药品分类:" prop="productType">
                            <el-select  v-model="medicinalAdd.productType" @change="chooseParentType" size="small" style="width: 240px;">
                                <el-option key="JIA_YONG_QI_XIE" label="家用器械" value="JIA_YONG_QI_XIE"></el-option>   
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属类别:" prop="productSubType">
                            <el-select  v-model="medicinalAdd.productSubType" size="small" style="width: 240px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option v-for="item in typeDetailList" :key="item.typeCode"
                                            :label="item.typeName" :value="item.typeCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="产品名称:" prop="productName">
                            <el-input v-model="medicinalAdd.productName" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="通用名:" prop="productPharmacyName">
                            <el-input v-model="medicinalAdd.productPharmacyName" style="width: 240px"></el-input>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="拼音简码:" prop="productPrefix">
                            <el-input v-model="medicinalAdd.productPrefix" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="产品规格:" prop="specification">
                            <el-input v-model="medicinalAdd.specification" style="width: 240px"></el-input>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="包装规格:" prop="packSpecification">
                           <el-input v-model="medicinalAdd.packSpecification" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="产品条形码:" prop="productBarCode">
                            <el-input v-model="medicinalAdd.productBarCode" style="width: 240px"></el-input>                
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        
                        <el-form-item label="产品技术要求编码:" prop="productNumber">
                            <el-input v-model="medicinalAdd.productNumber" style="width: 240px"></el-input>
                        </el-form-item>
                         <el-form-item label="医疗器械注册证编号:" prop="referenceNumber">
                            <el-input v-model="medicinalAdd.referenceNumber" style="width: 240px"></el-input>
                        </el-form-item>    
                    </div>

                </el-card>                

               <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>其他信息</span>
                    </div>
                <div class="dialog-set">
                      <el-form-item prop="quantityUnit" label="常规单位:" >
                        <el-select v-model="medicinalAdd.quantityUnit" style="width: 115px" >
                            <el-option label="台" value="TAI"></el-option>                            
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购单价:" prop="purchasePrice">
                        <el-input v-model="medicinalAdd.purchasePrice" style="width: 115px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="零售价格:" prop="price">
                        <el-input v-model="medicinalAdd.price" style="width: 115px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="库存:" prop="quantity">
                        <el-input v-model="medicinalAdd.quantity" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="库存下限:" prop="minQuantity">
                        <el-input v-model="medicinalAdd.minQuantity" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
               </el-card>
               <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>产品图片</span>
                    </div>
                    <div class="dialog-set">
                     <el-form-item label="产品主图:" prop="mainPic">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="medicinalAdd.mainPic"  class="course-img" :src="medicinalAdd.mainPic"></el-image>
                            <input type="file" class="upload-input" @change="addMainImg" accept="image/*" ref="mainPic"/>
                        </div>      
                    </el-form-item>
                     <el-form-item label="产品说明书:" prop="detailPic">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="medicinalAdd.detailPic"  class="course-img" :src="medicinalAdd.detailPic"></el-image>
                            <input type="file" class="upload-input" @change="addDetailImg" accept="image/*" ref="detailPic"/>
                        </div>      
                    </el-form-item>
                    </div>

               </el-card>
               <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>产品排序</span>
                    </div>
                     <div class="dialog-set">
                         <el-form-item >
                            <el-input v-model="medicinalAdd.sort" style="width: 240px"/><div style="margin: 7px 10px;font-size: 14px;color:rgba(153,153,153,1);"><span>数值越大，排名越高</span></div>
                            
                         </el-form-item>
                     </div>
               </el-card> 
               <!--
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>销售提成</span>
                    </div>
                     <div class="dialog-set">
                        <el-form-item label="医生提成:" prop="doctorPercent">
                            <el-input v-model="medicinalAdd.doctorPercent" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="业务员提成:" prop="salePercent">
                            <el-input v-model="medicinalAdd.salePercent" style="width: 240px"></el-input>
                        </el-form-item>                       
                     </div>
                      <div class="dialog-set">                       
                        <el-form-item label="经理提成:" prop="managerPercent">
                            <el-input v-model="medicinalAdd.managerPercent" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="主管提成:" prop="chargePercent">
                            <el-input v-model="medicinalAdd.chargePercent" style="width: 240px"></el-input>
                        </el-form-item>
                     </div>
               </el-card>       
               -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAdd">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑药材" :visible.sync="dialogEditVisible" width="740px" :close-on-click-modal="false">
           
            <el-form :model="medicinalEdit" label-width="100px" size="small" :rules="rule" ref="edit" style="margin-top: 20px">
                <el-card class="box-card">
                     <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="药品分类:" prop="productType">
                            <el-select  v-model="medicinalEdit.productType" @change="chooseParentType" size="small" style="width: 240px;">
                                <el-option key="JIA_YONG_QI_XIE" label="家用器械" value="JIA_YONG_QI_XIE"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属类别:" prop="productSubType">
                            <el-select  v-model="medicinalEdit.productSubType" size="small" style="width: 240px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option v-for="item in typeDetailList" :key="item.typeCode"
                                            :label="item.typeName" :value="item.typeCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="药品名称:" prop="productName">
                            <el-input v-model="medicinalEdit.productName" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="通用名:" prop="productPharmacyName">
                            <el-input v-model="medicinalEdit.productPharmacyName" style="width: 240px"></el-input>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="拼音简码:" prop="productPrefix">
                            <el-input v-model="medicinalEdit.productPrefix" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="产品规格:" prop="specification">
                            <el-input v-model="medicinalEdit.specification" style="width: 240px"></el-input>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="包装规格:" prop="packSpecification">
                           <el-input v-model="medicinalEdit.packSpecification" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="药品条形码:" prop="productBarCode">
                            <el-input v-model="medicinalEdit.productBarCode" style="width: 240px"></el-input>                
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        
                         <el-form-item label="产品技术要求编码:" prop="productNumber">
                            <el-input v-model="medicinalEdit.productNumber" style="width: 240px"></el-input>
                        </el-form-item>
                         <el-form-item label="医疗器械注册证编号:" prop="referenceNumber">
                            <el-input v-model="medicinalEdit.referenceNumber" style="width: 240px"></el-input>
                        </el-form-item>    
                    </div>

                </el-card>
     

               <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>其他信息</span>
                    </div>
                <div class="dialog-set">
                    <el-form-item prop="quantityUnit" label="常规单位:" >
                        <el-select v-model="medicinalEdit.quantityUnit" style="width: 115px" >
                            <el-option label="台" value="TAI"></el-option>                            
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购单价:" prop="purchasePrice">
                        <el-input v-model="medicinalEdit.purchasePrice" style="width: 115px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="零售价格:" prop="price">
                        <el-input v-model="medicinalEdit.price" style="width: 115px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="库存:" prop="quantity">
                        <el-input v-model="medicinalEdit.quantity" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="库存下限:" prop="minQuantity">
                        <el-input v-model="medicinalEdit.minQuantity" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
               </el-card>
               <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>产品图片</span>
                    </div>
                    <div class="dialog-set">
                     <el-form-item label="产品主图:" prop="mainPic">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="medicinalEdit.mainPic"  class="course-img" :src="medicinalEdit.mainPic"></el-image>
                            <input type="file" class="upload-input" @change="editMainImg" accept="image/*" ref="mainPic"/>
                        </div>      
                    </el-form-item>
                     <el-form-item label="产品说明书:" prop="detailPic">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="medicinalEdit.detailPic"  class="course-img" :src="medicinalEdit.detailPic"></el-image>
                            <input type="file" class="upload-input" @change="editDetailImg" accept="image/*" ref="detailPic"/>
                        </div>      
                    </el-form-item>
                    </div>

               </el-card>
               <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>产品排序</span>
                    </div>
                     <div class="dialog-set">
                         <el-form-item >
                            <el-input v-model="medicinalEdit.sort" style="width: 240px"/><div style="margin: 7px 10px;font-size: 14px;color:rgba(153,153,153,1);"><span>数值越大，排名越高</span></div>
                            
                         </el-form-item>
                     </div>
               </el-card> 
                <!--
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>销售提成</span>
                    </div>
                     <div class="dialog-set">
                        <el-form-item label="医生提成:" prop="doctorPercent">
                            <el-input v-model="medicinalEdit.doctorPercent" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="业务员提成:" prop="salePercent">
                            <el-input v-model="medicinalEdit.salePercent" style="width: 240px"></el-input>
                        </el-form-item>                       
                     </div>
                      <div class="dialog-set">                       
                        <el-form-item label="经理提成:" prop="managerPercent">
                            <el-input v-model="medicinalEdit.managerPercent" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="主管提成:" prop="chargePercent">
                            <el-input v-model="medicinalEdit.chargePercent" style="width: 240px"></el-input>
                        </el-form-item>
                     </div>
               </el-card>   
               -->    
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmEdit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提成设置" :visible.sync="dialogDividedSetVisible" width="560px" :close-on-click-modal="false">
            <el-form :model="dividedSet"  :rules="rule" label-width="100px" size="small">
                <div class="dialog-set">
                <el-form-item label="医生提成:" prop="doctorPercent">
                    <el-input v-model="dividedSet.doctorPercent" style="width: 120px"></el-input>
                </el-form-item>
                <el-form-item label="业务员提成:" prop="salePercent">
                    <el-input v-model="dividedSet.salePercent" style="width: 120px"></el-input>
                </el-form-item>                       
                </div>
                <div class="dialog-set">                       
                <el-form-item label="经理提成:" prop="managerPercent">
                    <el-input v-model="dividedSet.managerPercent" style="width: 120px"></el-input>
                </el-form-item>
                <el-form-item label="主管提成:" prop="chargePercent">
                    <el-input v-model="dividedSet.chargePercent" style="width: 120px"></el-input>
                </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="dialogDividedSetVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmDividedSet" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 搜索数据
                query: {
                   pharmacyId:'',
                   medicineStatus: '',
                   medicinalParentType:'JIA_YONG_QI_XIE',
                   medicinalType:''
                },
                // 表格页
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // loading
                loading: true,

                // 列表数据
                tableData: [],
                // medicinesDosage: [],
                pharmacyShow:true,
                pharmacies:[],
                // 产品类别
                typeList: [],
                // 次级分类
                typeDetailList: [],
                
                // 新增弹窗
                dialogAddVisible: false,
                // 表单验证
                rule:{
                    productName:[{required: true, message: '请输入药品名称', trigger: 'blur'}],                                   
                    productType: [{required: true, message: '请选择药品类别', trigger: 'change'}],
                    productSubType: [{required: true, message: '请选择所属类别', trigger: 'change'}],                    
                    price: [{required: true, message: '请输入药品零售价', trigger: 'blur'}],
                   
                },
                medicinalAdd: {
                    // 药品剂型 颗粒饮片1
                    productType: 'JIA_YONG_QI_XIE',
                    productSubType:'',
                    // 药品名称1
                    productName: '',
                    // 药品通用名1
                    productPharmacyName: '',
                    // 药品简码1
                    productPrefix: '',
                    // 单位1
                    quantityUnit: '',
                    specification: '',                    
                    // 药品次级类别
                    productSubTypeSub: '',
                    // 药品条形码
                    productBarCode: '',
                    // 药品批注文号
                    referenceNumber: '',
                    //
                    productNumber: '',
                    // 药品供应商1
                    supplier: '',                    
                    // 药品进价
                    purchasePrice: '',
                    // 零售价
                    price: '',
                    // 药品库存
                    quantity: '',
                    // 药品库存下限
                    minQuantity: '',
                    

                },
                dialogEditVisible: false,
                medicinalEdit: {
                    pharmacyNo:'',
                    productNo :'',
                    stockNo:'',
                    // 药品剂型 颗粒饮片1
                    productType: '',
                    productSubType:'',
                    // 药品名称1
                    productName: '',
                    // 药品通用名1
                    productPharmacyName: '',
                    // 药品简码1
                    productPrefix: '',
                    // 单位1
                    quantityUnit: '',
                    specification: '',                    
                    // 药品次级类别
                    productSubTypeSub: '',
                    // 药品条形码
                    productBarCode: '',
                    // 药品批注文号
                    referenceNumber: '',
                    // 
                    productNumber: '',
                    // 药品供应商1
                    supplier: '',                   
                    // 药品进价
                    purchasePrice: '',
                    // 零售价
                    price: '',
                    // 药品库存
                    quantity: '',
                    // 药品库存下限
                    minQuantity: '',
                    

                },
                dialogDividedSetVisible:false,
                dividedSet:{
                    pharmacyNo:'',
                    productNo :'',
                    stockNo:'',
                    doctorPercent:'',
                    salePercent:'',
                    managerPercent:'',
                    chargePercent:'',
                }
            }
        },
        methods: {
            getParams(){
                // 取到路由带过来的参数
                const routerParams = this.$route.query.pharmacyId
                // 将数据放在当前组件的数据内                
                
                this.query.pharmacyId = parseInt(routerParams)
                if(routerParams){             
                      
                    this.pharmacyShow = false                    
                }else{
                    this.query.pharmacyId = ''
                }                
                
            },
            getPharmacy() {
                let params = {
                    pageNum: 1,
                    pageSize: 999
                }
                this.axios.post('/api-b/10008/100088',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.pharmacies = res.data.data.list
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            search(){
                this.getData();
            },
            // 获取列表数据
            getData() {
                this.loading = true
                let params = {
                    pharmacyId:this.query.pharmacyId,
                    medicineStatus: this.query.medicineStatus,
                    medicinalParentType:this.query.medicinalParentType,
                    medicinalType:this.query.medicinalType,
                    medicinalName: this.query.medicinalName,
                }               
                this.axios.post('/api-b/10031/100166/' + this.pageNum + '/' + this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total
                        } else {
                            this.$message.info('暂无药材')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            // 打开新增
            openAdd() {
                this.dialogAddVisible = true
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                    this.medicinalAdd.productType = this.query.medicinalParentType
                    this.chooseParentType(this.query.medicinalParentType)
                })
            },
           
            // 获取产品类别
            getParentType() {                
                this.axios.get('/api-b/10038/100166',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.typeList = res.data.data
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(() => {})
            },
            // 选择产品类别
            chooseParentType(val) {
           
                this.axios.get('/api-b/10039/100149?parentCode='+val,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.typeDetailList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
           
            uploadImg(data) {
                return new Promise(resolve => {
                    this.axios.post('/api-f/10027/100065',data,{
                        headers:{
                            Authorization: this.authorization,
                            'Content-Type':'multipart/form-data'
                        }
                    }).then(res => {
                        resolve(res)
                    })
                })
            },
            addMainImg(){
                let inputDOM = this.$refs.mainPic;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'product')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.medicinalAdd.mainPic = res.data.data.filePath
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            addDetailImg(){
                let inputDOM = this.$refs.detailPic;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'product')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.medicinalAdd.detailPic = res.data.data.filePath
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            editMainImg(){
                let inputDOM = this.$refs.mainPic;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'product')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.medicinalEdit.mainPic = res.data.data.filePath
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            editDetailImg(){
                let inputDOM = this.$refs.detailPic;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'product')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.medicinalEdit.detailPic = res.data.data.filePath
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确认新增
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {}                       
                        params = {
                            pharmacyId:this.query.pharmacyId,
                            productType:this.medicinalAdd.productType,
                            productSubType:this.medicinalAdd.productSubType,                   
                            // 药品名称1
                            productName: this.medicinalAdd.productName,
                            // 药品通用名1
                            productPharmacyName: this.medicinalAdd.productPharmacyName,
                            // 药品简码1
                            productPrefix: this.medicinalAdd.productPrefix,
                            specification: this.medicinalAdd.specification,
                            // 单位1
                            quantityUnit: this.medicinalAdd.quantityUnit,
                            unitWeight: this.medicinalAdd.unitWeight,                    
                            // 药品进价
                            purchasePrice: this.medicinalAdd.purchasePrice,
                            // 零售价
                            price: this.medicinalAdd.price,
                            // 药品库存
                            quantity: this.medicinalAdd.quantity,
                            // 药品库存下限
                            minQuantity: this.medicinalAdd.minQuantity,
                            productSubTypeSub: this.medicinalAdd.productSubTypeSub,
                            productBarCode: this.medicinalAdd.productBarCode,
                            productNumber: this.medicinalAdd.productNumber,
                            referenceNumber: this.medicinalAdd.referenceNumber,                            
                            mainPic: this.medicinalAdd.mainPic,
                            detailPic: this.medicinalAdd.detailPic,
                            sort: this.medicinalAdd.sort,
                            
                        }
                        
                        this.axios.post('/api-b/10031/100210/',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                })
                            } else  {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                })
            },
            // 获取药材详情,打开编辑
            editMedicinal(data) {
                let params = new FormData()
                params.append('stockNo',data.stockNo)
                this.axios.post('/api-b/10031/100211/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.medicinalEdit = res.data.data               
                        this.dialogEditVisible = true
                        this.getParentType()
                        this.chooseParentType(this.medicinalEdit.productType)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            // 编辑弹窗选择制剂单位
            editSelectProductType(val) {
                this.editOneUnit = this.oneUnitList.find(item => {
                    return item.value === val
                }).label
            },
            // 确认编辑
            confirmEdit() {
                let params = {}
               
                params = {
                    pharmacyNo:this.medicinalEdit.pharmacyNo,
                    productNo :this.medicinalEdit.productNo,
                    stockNo:this.medicinalEdit.stockNo,
                    status:this.medicinalEdit.status,
                    pharmacyId:this.query.pharmacyId,
                    productType:this.medicinalEdit.productType,
                    productSubType:this.medicinalEdit.productSubType,                   
                    // 药品名称1
                    productName: this.medicinalEdit.productName,
                    // 药品通用名1
                    productPharmacyName: this.medicinalEdit.productPharmacyName,
                    // 药品简码1
                    productPrefix: this.medicinalEdit.productPrefix,
                    specification: this.medicinalEdit.specification,
                    // 单位1
                    quantityUnit: this.medicinalEdit.quantityUnit,
                    unitWeight: this.medicinalEdit.unitWeight,                    
                    // 药品进价
                    purchasePrice: this.medicinalEdit.purchasePrice,
                    // 零售价
                    price: this.medicinalEdit.price,
                    // 药品库存
                    quantity: this.medicinalEdit.quantity,
                    // 药品库存下限
                    minQuantity: this.medicinalEdit.minQuantity,
                    productSubTypeSub: this.medicinalEdit.productSubTypeSub,
                    productBarCode: this.medicinalEdit.productBarCode,
                    productNumber: this.medicinalEdit.productNumber,
                    referenceNumber: this.medicinalEdit.referenceNumber,                    
                    mainPic: this.medicinalEdit.mainPic,
                    detailPic: this.medicinalEdit.detailPic,
                    sort: this.medicinalEdit.sort,
                    
                }
                
                this.axios.post('/api-b/10031/100212/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
           // 药材上下架
            changeStatus(data){
                const h = this.$createElement;
                let msg  = '';
                if (data.status === 'SHELF') {
                    msg = '确定要下架该产品吗？'
                } else {
                    msg = '确定要上架该产品吗？'
                }
                this.$msgbox({               
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, msg),
                        ])
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    
                let params = {
                    pharmacyNo: data.pharmacyNo,
                    productNo: data.productNo,                    
                }
                if (data.status === 'SHELF') {
                    params.status = 'OBTAINED'
                } else {
                    params.status = 'SHELF'
                }
                this.axios.post('/api-b/10031/100134',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000){
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                    }).catch(error => {})
                })            

            },
            excelExport(){
               this.axios.get('/api-b/10031/100221',{
                    headers:{
                        Authorization: this.authorization
                    }, responseType: "blob"
                }).then(response => {                   
                        const BLOB = response.data;
                        const headers = response.headers
                        this.fileName = JSON.parse(JSON.stringify(headers));
                        let arr = this.fileName["content-type"].split(";");
                        this.fileName = arr[1];     
                        let ar = this.fileName.split("=");
                        this.fileName = ar[1];                   
                        // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB);
                        // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = revertUTF8(this.fileName);
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                    
                })
            },
             dataExport(){              
               this.axios.get('/api-b/10031/100218',{
                    params:{
                       pharmacyId:this.query.pharmacyId,
                       medicineStatus: this.query.medicineStatus,
                       medicinalParentType:this.query.medicinalParentType,
                       medicinalType:this.query.medicinalType,                      
                    },
                    headers:{
                        Authorization: this.authorization
                    }, responseType: "blob"
                }).then(response => {                   
                        const BLOB = response.data;
                        const headers = response.headers
                        this.fileName = JSON.parse(JSON.stringify(headers));
                        let arr = this.fileName["content-type"].split(";");
                        this.fileName = arr[1];     
                        let ar = this.fileName.split("=");
                        this.fileName = ar[1];                   
                        // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB);
                        // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = revertUTF8(this.fileName);
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                    
                })
            },
        uploadFile(item){            
            let params = new FormData()
            params.append('file',item.file)
            params.append('pharmacyId',this.query.pharmacyId)
            this.axios.post('/api-b/10031/100222',params,{
                    headers:{
                        Authorization: this.authorization,
                        'Content-Type':'multipart/form-data'
                    }
            }).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.getData()                        
                } else {
                    this.$message.error(res.data.message)
                }
            })

        },
        openDividedSet(data) {
                let params = new FormData()
                params.append('stockNo',data.stockNo)
                this.axios.post('/api-b/10031/100219/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dividedSet = res.data.data               
                        this.dialogDividedSetVisible = true                        
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
        confirmDividedSet(){
            let params = {}
               
                params = {
                    pharmacyNo:this.dividedSet.pharmacyNo,
                    productNo :this.dividedSet.productNo,
                    stockNo:this.dividedSet.stockNo,
                    pharmacyId:this.query.pharmacyId,
                    doctorPercent: this.dividedSet.doctorPercent,
                    salePercent: this.dividedSet.salePercent,
                    managerPercent:this.dividedSet.managerPercent,
                    chargePercent:this.dividedSet.chargePercent,
                }
                this.axios.post('/api-b/10031/100220/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogDividedSetVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

        }
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep:true
            },
            '$route': 'getParams'
        },
        created() {
            this.getPharmacy() 
            this.getParentType()
            this.getData()
            this.getParams()
            
        }
    }
    function revertUTF8(szInput) {
    var x,wch,wch1,wch2,uch="",szRet="";
    for (x=0; x<szInput.length; x++) {
        if (szInput.charAt(x)=="%") {
            wch =parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
            if (!wch) {break;}
            if (!(wch & 0x80)) {
                wch = wch;
            } else if (!(wch & 0x20)) {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x1F)<< 6;
                wch1 = wch1 & 0x3F;
                wch  = wch + wch1;
            } else {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                x++;
                wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x0F)<< 12;
                wch1 = (wch1 & 0x3F)<< 6;
                wch2 = (wch2 & 0x3F);
                wch  = wch + wch1 + wch2;
            }
            szRet += String.fromCharCode(wch);
        } else {
            szRet += szInput.charAt(x);
        }
    }
    return(szRet);
}
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-upload{
        border: none!important;
    }
    .el-upload--text {
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height:36px;
        margin-top: -25px;
        font-size: 14px
    }
    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: center
    }
    .active{
        box-shadow: 0 2px 0 rgba(97,167,255,1);
        color:rgba(97,167,255,1);
    }
     .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
     .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>